import { render } from "./TestTag.vue?vue&type=template&id=ff7ab448&scoped=true"
import script from "./TestTag.vue?vue&type=script&lang=js"
export * from "./TestTag.vue?vue&type=script&lang=js"

import "./TestTag.vue?vue&type=style&index=0&id=ff7ab448&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7ab448"]])

export default __exports__